module.exports = __webpack_public_path__ + "img/collection-weddingRingsMokumeGane@2x.30b7093.webp";